import { Button } from '@design-systems/canvas-ui'
import { MPMLayout } from 'components/layout'
import { FallbackProps } from 'react-error-boundary'
import { ErrorAlert } from './error-alert'
import Icon, { RefreshIcon } from '@design-systems/react-icons'
import { messages } from './messages'
import { useLogClick } from 'utils/analytics'
import { safeTgtLogger } from 'utils/safeTgtLogger'
import { useEffect } from 'react'

type ExtendedFallbackProps = FallbackProps & {
    heading?: string
    additionalInfo?: string
}

export const ErrorFallback: React.FC<ExtendedFallbackProps> = ({
    error,
    resetErrorBoundary,
    heading = 'Error',
}) => {
    const { logClick } = useLogClick('error fallback')

    useEffect(() => {
        safeTgtLogger.error('Error boundary caught an error', {
            error: {
                message: error instanceof Error ? error.message : String(error),
                type: error instanceof Error ? error.name : 'Unknown',
                stack_trace: error instanceof Error ? error.stack : undefined,
            },
            event: {
                action: 'error_boundary_triggered',
                category: 'error_handling',
                outcome: 'failure',
            },
            nonIndexedFields: {
                page_heading: {
                    heading,
                },
            },
        })
    }, [error, heading])

    const handleReset = () => {
        logClick('reset error boundary')
        resetErrorBoundary()
    }

    return (
        <MPMLayout heading={heading}>
            <ErrorAlert error={error} />
            <Button onClick={handleReset} className="reset-error-boundary">
                <Icon svg={RefreshIcon} aria-hidden />{' '}
                <span>{messages.retry}</span>
            </Button>
        </MPMLayout>
    )
}
